import { KlesDynamicFieldDirective, KlesFieldAbstract } from "@3kles/kles-material-dynamicforms";
import { KlesColumnConfig } from "@3kles/kles-material-table";
import { ComponentFactoryResolver, ComponentRef, Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewContainerRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LeafComponent } from "../component/cell/leaf.component";
import { NodeComponent } from "../component/cell/node.component";
import { KlesTreeColumnConfig } from "../models/columnConfig.model";

@Directive({
    selector: '[klesDynamicCell]'
})
export class KlesDynamicCellDirective extends KlesDynamicFieldDirective implements OnInit, OnChanges, OnDestroy {

    @Input() column: KlesTreeColumnConfig;
    @Input() row: FormGroup;

    ngOnInit() {
        this.buildComponent();
    }


    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    buildComponent() {

        const factory = this.resolver.resolveComponentFactory(
            this.row.value._status.children && this.column.canExpand ? NodeComponent : LeafComponent
        );

        if (this.componentRef) this.componentRef.destroy();

        this.componentRef = this.container.createComponent(factory);
        this.componentRef.instance.field = this.field;
        this.componentRef.instance.group = this.group;
        this.componentRef.instance.row = this.row;
        this.componentRef.instance.column = this.column;

    }

}